<div *ngIf="lead" class="container-fluid">
  <app-header titleText="LEADS" i18n-titleText progressBarState="lead">

    <div button>
      <div *ngIf="lead.quote_ID">
        <a *ngIf="canAddQuote" routerLink="/lead/convert/{{lead.quote_ID}}" class="btn btn-bidit-navigate mr-1" i18n>Convert to Quote</a>
        <button *ngIf="canEdit" class="btn btn-bidit-warn" (click)="expireLead()" i18n>Expire Lead</button>
      </div>
    </div>
  </app-header>

  <div class="card bg-light">
    <div class="card-body">
      <img src="assets/img/circle_images/leads_circle.png" alt="Lead Icon" class="card-icon" />
      <div *ngIf="lead.customer" class="container-fluid">
        <h5>{{lead.customer.customer_BusinessName}}</h5>
        <div class="row header-text">
          <div class="col-3">
            <span *ngIf="lead.customer.customer_Address1">{{lead.customer.customer_Address1}}<br /></span>
            <span *ngIf="lead.customer.customer_Address2">{{lead.customer.customer_Address2}}<br /></span>
            <span *ngIf="lead.customer.customer_City || lead.customer.customer_State || lead.customer.customer_Post">{{lead.customer.customer_City}}, {{lead.customer.customer_State}} {{lead.customer.customer_Post}}<br /></span>
            <span i18n>Contact:</span> {{lead.customer.contact_LastName}}, {{lead.customer.contact_FirstName}}<br />
            <span *ngIf=lead.customer.contact_Phone><span i18n>Phone:</span> {{lead.customer.contact_Phone}}<br /></span>
            <span *ngIf=lead.customer.contact_Mobile><span i18n>Cell:</span> {{lead.customer.contact_Mobile}}<br /></span>
            <span *ngIf=lead.customer.contact_Email>{{lead.customer.contact_Email}}<br /></span>
          </div>
          <div class="col-3">
            <span *ngIf="lead.jobType_ID">{{lead.jobType.jobType_Desc}}<br /></span>
            <span i18n>Office:</span> <span *ngIf="lead.office">{{lead.office.office_Name}}</span><br />
            <span i18n>Salesperson:</span> <span *ngFor="let assignment of lead.quoteAssignments">{{assignment.assignedTo.firstName}} {{assignment.assignedTo.lastName}}</span><br />
            <span i18n>Blueprint Revision Date:</span> {{lead.quote_PlanDate | date: 'MM/dd/yyyy'}}<br />
            <span i18n>Estimated Start Date:</span> {{lead.quote_ReadyDate | date: 'MM/dd/yyyy'}}<br />
          </div>
          <div class="col-3">
            <span i18n>Project:</span> {{lead.quote_Name}} #{{lead.quote_ProjectNumber}}<br />
            <span i18n>Job Address</span><br />
            <span *ngIf="lead.quote_Address1">{{lead.quote_Address1}}<br /></span>
            <span *ngIf="lead.quote_Address2">{{lead.quote_Address2}} <br /></span>
            <span *ngIf="lead.quote_City || lead.quote_State || lead.customer_Post">{{lead.quote_City}}, {{lead.quote_State}} {{lead.quote_Post}}<br /></span>
          </div>
          <div class="col-sm-3" align="right">
            <h7><span i18n>Created By:</span> <ng-template [ngIf]="lead.createdBy">{{lead.createdBy.firstName}} {{lead.createdBy.lastName}}</ng-template><br /></h7>
            <h7><span i18n>Date:</span> {{lead.quote_Created | date: 'M/d/yyyy'}}</h7><br />
            <a href="http://maps.google.com/?q={{lead.quote_Address1}},{{lead.quote_City}}%20{{lead.quote_State}}%20{{lead.quote_Postal}}" target="_blank" class="btn btn-bidit-navigate" i18n>Map Lead</a>
          </div>
        </div>

      </div>
      <br>

      <mat-tab-group>
        <mat-tab label="Lead Info" i18n-label>
          <app-project-info projectType="lead" [quote]="lead" (updated)="leadUpdated($event)"></app-project-info>
        </mat-tab>
        <mat-tab *ngIf="lead.notes" [label]="noteLabel">
          <app-project-notes [project]="lead"
                             (updated)="leadUpdated($event)"></app-project-notes>
        </mat-tab>
        <mat-tab *ngIf="lead.documents" [label]="documentLabel">
          <app-project-documents [project]="lead"
                                 (updated)="leadUpdated($event)"></app-project-documents>
        </mat-tab>
      </mat-tab-group>

    </div>

  </div>
</div>
